// 归档转发
export const garbageVirus = {
    data() {
        return {
            tanchu_forward: false,
            forword_email: '',
            is_spam: '',
            data_forword: '',
            data_forword_address: '',
            islocal: '',
        }
    },
    methods: {
        tanOff_archive_forward() {
            this.tanchu_forward = false;
        },
        // 归档转发
        save_archive_forward() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            var arr = this.multipleSelection;
            // console.log(arr, "全选后，获取的数组");
            let multis = [];
            for (var i = 0; i < arr.length; i++) {
                multis.push(arr[i].SEL_ID);
            }
            // console.log(multis, "选中后的批量放行id");
            let multis1 = JSON.stringify(multis);
            let str = this.$qs.stringify({
                __mode: "forword_elk_data",
                sid: sid,
                is_spam: this.is_spam,
                msg_json: multis1,
                islocal: this.islocal,
                forword_email: this.forword_email,
            });

            this.$axios.post("/api/adm/cgi/elkspam.cgi", str).then((res) => {
                console.log(res);

                if (!res.data.fmstatus) {
                    alert(res.data);
                } else if (res.data.fmstatus.code == "1") {
                    alert(res.data.fmstatus.errmsg);
                } else if (res.data.fmstatus.code == "2") {
                    alert(res.data.fmstatus.errmsg);

                } else if (res.data.fmstatus.code == "3") {
                    alert(res.data.fmstatus.errmsg);
                    this.$router.push({
                        name: "login",
                    });
                } else {
                    this.loading = false;
                    this.$refs.multipleTable.clearSelection()
                    this.tanchu_forward = false;
                    this.$message({
                        type: "success",
                        message: `${this.$t("confirm.transpond")}`,
                    });
                }
            });
        },

        // 归档转发
        archive_forward_tanchu() {
            if (this.$root.jurisdiction.only_query != 0 && this.authority_to_judge.forward == 1) {
                if (this.multipleSelection.length === 0) {
                    this.$message({
                        message: "请至少勾选一项，再进行操作",
                        type: "warning",
                    });
                    return;
                } else {
                    this.forword_email = "";
                    this.tanchu_forward = true;
                }
            } else {
                this.$message({

                    message: `${this.$t("tan.not_pre")}`,
                    type: "error",
                });
            }
        },
        // 自定义隔离列表归档转发
        archive_forward_tanchu_custom() {
            // if (this.$root.jurisdiction.only_query != 0) {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: "请至少勾选一项，再进行操作",
                    type: "warning",
                });
                return;
            } else {
                this.forword_email = "";
                this.tanchu_forward = true;
            }
            // }
        },
    }
}